import { Component } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { Icons } from 'src/app/types/icons';

@Component({
  selector: 'app-month-picker-header',
  templateUrl: './month-picker-header.component.html',
  styleUrls: ['./month-picker-header.component.scss'],
  standalone: false,
})
export class MonthPickerHeaderComponent<D> {
  _currentDate: Date = new Date();

  Icons = Icons;

  constructor(
    private _calendar: MatCalendar<Date>,
    private _dateAdapter: DateAdapter<Date>,
  ) {
    this._calendar.maxDate = new Date();
  }

  clickPrevYear(): void {
    this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  clickNextYear(): void {
    this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }

  canClickNextYear(): boolean {
    if (!this._calendar.activeDate) {
      return true;
    }

    let activeDate: Date = this._calendar.activeDate;
    return activeDate.getFullYear() < this._currentDate.getFullYear();
  }
}
